/* eslint-disable import/prefer-default-export */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { EventDetail } from 'events/_types';

const POLL_INTERVAL_MS = 30_000;

export function useEvent(eventId: string) {
  return useQuery<EventDetail>({
    queryKey: [APIKey.EVENT, eventId],
    queryFn: () => baseFetcher(apiRoutes.event(eventId)),
    enabled: !!eventId,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
}

export function useInvalidateEvent() {
  const queryClient = useQueryClient();
  return (eventId: string) =>
    queryClient.invalidateQueries({
      queryKey: [APIKey.EVENT, eventId],
    });
}

export function useToggleEventPin(eventId: string) {
  const queryClient = useQueryClient();

  return useMutation<EventDetail, unknown, boolean>({
    mutationFn: (pinned) =>
      baseFetcher(apiRoutes.event(eventId), {
        method: 'PATCH',
        data: { pinned },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [APIKey.EVENT, eventId] });
      queryClient.invalidateQueries({ queryKey: [APIKey.EVENT, 'list'] });
    },
  });
}
